export default __webpack_public_path__ + "b6515710094abf0da7b93f2dd4730667.png";